module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "company"
  }, [_c('div', {
    staticClass: "company-header"
  }, [_c('i', {
    staticClass: "arrow"
  }), _vm._v(" "), _c('i', {
    staticClass: "arrow-bg"
  }), _vm._v(" "), _c('span', [_vm._v("\r\n\t\t\t\t优质厂家\r\n\t\t\t")]), _vm._v(" "), _c('span', {
    staticClass: "fr",
    staticStyle: {
      "font-size": "14px",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.goEntry
    }
  }, [_vm._v("\r\n\t\t\t\t查看更多\r\n\t\t\t\t"), _c('i', {
    staticClass: "icon-gengduo"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "company-body clearfix"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "company-body-right fl"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('ts-carousel', {
    attrs: {
      "height": "523px",
      "autoplay-speed": "6000",
      "dots": "none",
      "autoplay": "",
      "arrow": "always",
      "easing": "linear"
    }
  }, _vm._l((_vm.companys), function(company, index) {
    return _c('ts-carousel-item', {
      key: index
    }, [_c('ts-grid', _vm._l((company), function(item) {
      return _c('ts-grid-item', {
        staticStyle: {
          "width": "289px",
          "height": "160px"
        },
        on: {
          "click": function($event) {
            _vm.handleViewProduct(item)
          }
        }
      }, [_c('ts-image', {
        attrs: {
          "width": "258",
          "height": "130",
          "canView": false,
          "disabledHover": "",
          "src": item.pic
        }
      })], 1)
    }))], 1)
  }))], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "company-body-left fl"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/lace.jpg"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-7fecdfa8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/homePageLists/entry-list.vue
// module id = 848
// module chunks = 39